<script>
    import { createEventDispatcher } from 'svelte';
    import { sgettext } from '../../i18n.js';
    import { elementTypesWithAll, strategyElementTypesWithAll , contextualStrategyElementTypesWithAll } from '../Workspaces/workspacesStore.js';

    const dispatch = createEventDispatcher();
    const allTypeElement = $elementTypesWithAll.find(el => el.id == "ALL")

    export let selectedElementTypes = [allTypeElement];
    export let diffType = "";
    export let isContextualDiff = false;
    export let isAPM = false;

    let showPopup = false;
    $: elementTypesToList = diffType == "STRATEGY" ? (isAPM ? $contextualStrategyElementTypesWithAll : $strategyElementTypesWithAll) : $elementTypesWithAll

    // default to "ALL" when nothing is selected
    $: if(selectedElementTypes.length == 0) {
        selectedElementTypes = [allTypeElement]
        emitSelectionChange();
    }

    $: if(selectedElementTypes.length != 0) {
        emitSelectionChange();
    }

    function emitSelectionChange() {
        let typesToFilter = selectedElementTypes.map(el => el.id);
        dispatch("selectionChange", { typesToFilter: typesToFilter });
    }

    function togglePopup(event) {
        showPopup = !showPopup;
    }

    function removeType(element) {
        selectedElementTypes = selectedElementTypes.filter(el => el.id != element.id)
        emitSelectionChange();
    }

    function removeAllType() {
        selectedElementTypes = selectedElementTypes.filter(el => el.id != allTypeElement.id)
    }

    function handleElementSelectionChange(event, element) {
        let selectionChanged = false;
        let elementType = element.id;
        if (event.target.checked) {
            if (elementType === "ALL") {
                selectedElementTypes = [allTypeElement]
                selectionChanged = true
            }
            else if (!selectedElementTypes.find(el => el.id == elementType)) {
                selectedElementTypes = [...selectedElementTypes, element];
                removeAllType();
                selectionChanged = true;
            }
        } else {
            if(selectedElementTypes.find(el => el.id == elementType)) {
                selectedElementTypes = selectedElementTypes.filter(el => el.id != elementType)
                selectionChanged = true;
            }
        }

        if (selectionChanged) {
            emitSelectionChange();
        }
    }
</script>

<div style="position: relative;">
  <span class="label-in-border" for="id_multi_element_filter">
    {sgettext('$$FILTER_ELEMENT_TYPES$$')}
  </span>
  <div
    id="id_multi_element_filter"
    class="p-2 m-1 mb-2 input-container d-flex justify-content-between align-items-center"
    on:click|stopPropagation={togglePopup}
  >
    <div class="pt-1 d-flex">
      {#each selectedElementTypes as element}
        <span
          class="badge rounded-pill bg-secondary text-light p-2 mr-2 d-flex justify-content-between align-items-center"
          style="background-color: #ddd !important;"
        >
          <span class="mr-1 text-dark">{sgettext(element.name)}</span>
          {#if element.id !== 'ALL'}
            <div
              class="close-icon-style d-flex justify-content-center align-items-center"
            >
              <i
                class="fa fa-close text-light p-0 m-0"
                on:click|stopPropagation={() => removeType(element)}
              />
            </div>
          {/if}
        </span>
      {/each}
    </div>
    <div class="d-flex align-items-center">
      <i
        class="fa float-right pr-2 text-primary {showPopup
          ? 'fa-caret-up'
          : 'fa-caret-down'}"
      />
    </div>
  </div>

  <!-- Popup with Element Type options  -->
  {#if showPopup}
    <div class="element-types-pop-up">
      <ul class="list-group mx-1">
        {#each elementTypesToList as element}
          <label class="list-group-item">
            <div class="ml-2">
              <input
                class="form-check-input me-1"
                type="checkbox"
                value={element.id}
                disabled={element.id == 'ALL' &&
                  selectedElementTypes.find((el) => el.id == 'ALL')}
                checked={selectedElementTypes.find((el) => el.id == element.id)}
                on:change|stopPropagation={(event) =>
                  handleElementSelectionChange(event, element)}
              />
              <span class="ml-2"
                ><i
                  class={element.faIcon.classes + ' mr-2'}
                  style={element.faIcon.style}
                />{sgettext(element.name)}</span
              >
            </div>
          </label>
        {/each}
      </ul>
    </div>
  {/if}
</div>

<style>
  .element-types-pop-up {
    position: absolute;
    z-index: 100;
    width: 100%;
    top: 55px;
    left: 0px;
    padding-left: 0;
  }

  .close-icon-style {
    display: inline-block;
    background-color: #777;
    height: 16px;
    width: 16px;
    border-radius: 8px;
    font-weight: normal;
    vertical-align: middle;
  }

  .input-container {
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 5px;
    height: 53px;
  }

  .label-in-border {
    position: absolute;
    font-weight: bold;
    font-size: small;
    top: -110px;
    left: 15px;
    z-index: 10;
    background-color: #eee;
    padding: 0 4px;
    border-radius: 2px;
    margin-top: 100px !important;
  }

  .list-group {
    border: 1px solid #bbb;
    border-radius: 5px;
  }

  .list-group-item {
    height: 2rem;
    display: flex;
    align-items: center;
    font-weight: normal;
    font-size: 0.9rem;
    border: unset;
    background-color: white;
  }

  .list-group-item:hover {
    background-color: #eee;
  }
</style>
